export const DECODED_KEY_ADDRESS = 'address'
export const DECODED_KEY_CATEGORIES = 'categories'
export const DECODED_KEY_FIRST_NAME = 'firstName'
export const DECODED_KEY_LAST_NAME = 'lastName'
export const DECODED_KEY_NAME = 'name'
export const DECODED_KEY_PHONE = 'phone'
export type DecodedKey =
  'address'
  | 'categories'
  | 'firstName'
  | 'lastName'
  | 'phone'
  | 'name';
